import { CMSUserProfile } from "@types";

export interface UserProfile {
    codsId: string;
    country?: string;
    email: string;
    emailVerified: boolean;
    individualType: string;
    internationalSpecialty: string;
    isValidated: boolean;
    lastName: string;
    locale: string;
    specialty: string;
}

export const isValidUserProfile = (userProfile: UserProfile, allowedUserProfiles: CMSUserProfile[]): boolean => {
    // if no allowed user profiles are set in the CMS, then the user profile is considered valid
    if (userProfile && (!allowedUserProfiles || !allowedUserProfiles.length)) {
        return true;
    }

    // if no userProfile is available, then we don't consider it valid
    if (!userProfile) {
        return false;
    }

    return allowedUserProfiles.some((profile) => {
        const matchesIntSpecialty = profile.international_specialty?.length
            ? profile.international_specialty.includes(userProfile?.internationalSpecialty)
            : true;
        const matchesIndividualType = profile.ind_type_select?.length
            ? profile.ind_type_select.includes(userProfile?.individualType)
            : true;
        const matchesCountry = profile.country?.length ? profile.country.includes(userProfile?.locale) : true;
        return matchesIntSpecialty && matchesIndividualType && matchesCountry;
    });
};
